<template>
  <a-row class="statistics-card" type="flex" justify="space-between" align="middle">
    <a-col :span="8" class="card-header">
      <p class="title">{{ title }}</p>
      <p class="total">
        <span class="number" :title="cardData.count | NumberFormat">
          <count-to  
            :startVal='numberFomartToSample(beforeCount, 4)' 
            :endVal='numberFomartToSample(cardData.count, 4)' 
            :duration='countToDuration' 
            :decimals="cardData.count.toString().length > 4 ? 2 : 0"
          />
        </span>
        {{
          cardData.count.toString().length > 4 
            ? `${$t('dashboard.tenThousand')}${cardData.unit}` 
            : cardData.unit
        }}
      </p>
    </a-col>
    <a-col :span="10" class="card-content">
      <a-row 
        type="flex" justify="start" align="middle"
        v-for="(sub, index) in cardData.sub"
        :key="index"
      >
        <label>{{ sub.title }}</label>
        <span :style="{color:subColor[index]}" :title="sub.count | NumberFormat">
          <count-to  
            :startVal='numberFomartToSample(beforeSubCount[index], 5)' 
            :endVal='numberFomartToSample(sub.count, 5)' 
            :duration='countToDuration'
            :decimals="sub.count.toString().length > 5 ? 2 : 0"
          />
          <span v-if="sub.count.toString().length > 5 " style="font-size:14px">$t('dashboard.tenThousand')</span>
        </span>        
      </a-row>
    </a-col>
    <a-col :span="6" class="card-chart">
      <v-chart 
        v-if="cardData.count" 
        :force-fit="true" 
        :height="70" 
        :data="pieData" 
        :scale="pieScale" 
        padding="auto"
      >
        <v-tooltip :showTitle="false" dataKey="item*percent" />
        <v-pie position="percent" :color="color" :vStyle="pieStyle" />
        <v-coord type="theta" :innerRadius="0.6" />
      </v-chart>
      <img v-if="cardData.count" class="chart-icon" :src="require(`../../../assets/dashboard/${chartIcon}`)" alt="">
    </a-col>
  </a-row>
</template>

<script>
import countTo from 'vue-count-to'
import { numberFomartToSample } from '@/utils/utils'

const DataSet = require('@antv/data-set')
const pieScale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}]

export default {
  name: 'StatisticsCard',
  components: { countTo },
  props: {
    title: {
      type: String
    },
    chartIcon: {
      type: String
    },
    cardData: {
      type: Object,
      required: true
    },
    subColor: {
      type: Array,
      default: () => ['#00aeff', '#ffb400']
    }
  },
  data () {
    return {
      countToDuration: 3000,
      beforeCount: 0,
      beforeSubCount: new Array(this.cardData.sub.length).fill(0),

      pieData: null,

      pieScale,      
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      },
      color: ['item', ['#00AEFF', '#FFB400']]
    }
  },
  watch: {
    cardData: function (newVal, oldVal) {
      this.beforeCount = oldVal.count
      oldVal.sub.forEach((sub, index) => {
        this.beforeSubCount[index] = sub.count
      })

      this.pieData = this.getPieData(newVal.sub.map(val => {
        return { item: val.title, count: val.count }
      }))
    }
  },
  computed: {},
  methods: {
    numberFomartToSample,

    getPieData(sourceData) {
      const dv = new DataSet.View().source(sourceData)
      dv.transform({
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      })
      return dv.rows
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-card {
  background-image: url('../../../assets/dashboard/statistics_card.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  padding-left: 10px;

  .card-header{
    padding: 25px 5px 40px 0;
    position: relative;
    .title{
      margin-bottom: 0;
      font-size: 16px;
    }
    .total {
      margin-bottom: 0;
      color: #00fffc;

      .number{
        font-size: 30px;
      }
    }
  }
  .card-header:after{
    content: '';
    width: 1px;
    height: 65px;
    border-right: 1px dashed rgba(255,255,255,0.25);
    position: absolute;
    right: 0;
    top: 25px;
  }

  .card-content{
    padding-left: 10px;
    padding: 25px 0 40px 10px;

    label{
      margin-right: 10px;
    }
    span{
      font-size: 24px;
    }
  }

  .card-chart{
    margin-bottom: 5px;
    position: relative;

    .chart-icon{
      width: 28px;
      height: 28px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -17px;
      margin-left: -14px;
    }
  }
}
</style>
